import { FC, HTMLAttributes } from 'react'

export const LongArrowUp: FC<HTMLAttributes<SVGElement>> = (props) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M11.7256 4.25L11.7256 19.25"
      stroke="#350174"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5.701 10.2988L11.725 4.24883L17.75 10.2988"
      stroke="#350174"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)
